import React from 'react';
import { Flex, Box } from '@withjoy/joykit';
import { useTranslation } from '@shared/core/i18n';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

import { useCatalogContext } from '../../state/Catalog';
import { BrowserButtonSection } from '../BrowserButtonSection';
import { useLineageTitles } from '../../hooks/useLineageTitles';
import { CatalogEmptyStateHero } from '../CatalogEmptyStateHero';
import ValuePropsSection from '../../routes/CatalogProductsIndex/components/ValuePropsSection';
import { DepartmentNavSection } from '../../routes/CatalogProductsIndex/components/DepartmentNavSection';
import RecommendedProductsSection from '../../routes/CatalogProductsIndex/components/RecommendedProductsSection';

const HERO_BACKGROUND_IMAGE = 'https://withjoy.com/assets/public/shop/homeHero/baby/catalog-empty-desktop.jpeg';

export const BabyCatalogEmptyState: React.FC = () => {
  const { eventId, isAdminView } = useCatalogContext();
  const lineageTitles = useLineageTitles();
  const isMobileOrTablet = useIsMobileOrTablet();
  const { t } = useTranslation('catalogRegistry');
  const { title, subtitle } = t('babyCatalogEmptyStateContent');
  const selectedCategory = lineageTitles.length ? lineageTitles[lineageTitles.length - 1]?.category.title : '';

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <CatalogEmptyStateHero
        title={title()}
        description={subtitle({ selectedCategory })}
        backgroundImage={HERO_BACKGROUND_IMAGE}
        containerStyles={{ backgroundColor: ['warning2', 'transparent'] }}
      />
      {!isMobileOrTablet && eventId && isAdminView && (
        <Box paddingBottom={10}>
          <BrowserButtonSection eventId={eventId} />
        </Box>
      )}
      <RecommendedProductsSection eventId={eventId} hideHeader={true} />
      <ValuePropsSection showTitle={true} />
      <DepartmentNavSection />
    </Flex>
  );
};
